/**
 * Режим «Термінал» на ЦЬОМУ пристрої (ТЗ2, Danyil 04.11.2026): ключ, який видав
 * адмін у Пульті. Є ключ — екран входу веде на «Скануй бейдж» (/work-terminal).
 */
const KEY = "mes-terminal-key";

export function terminalKey(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function makeTerminal(key: string): void {
  localStorage.setItem(KEY, key);
}

export function forgetTerminal(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* сховище недоступне — і ключа там нема */
  }
}
